import React, { useState } from "react";
import Popup from "./Popup";
import './styles/EditTaskForm.css';
import { TwitterPicker } from 'react-color';
import DayPicker from "./DayPicker";

const EditTaskForm = ({user, setUser, taskToEdit, dismiss}) => {
    
    const [task, setTask] = useState(taskToEdit)
    const [color, setColor] = useState(task.color != null ? task.color : '#FFFFFF')
    const [showColors, setShowColors] = useState(false)

    const toggleColors = () => {setShowColors(!showColors)}

    // Delete
    const delTask = async (task) => {
        // Create date stamp - verify data date.
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        if (dateStamp !== user.lastLogin) {
            alert('Session Expired. Please sign in again.')
            setUser(null)
            return
        }
        const res = await fetch('https://GradientBack.3-sigma.repl.co/task', {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({sessionToken: user.sessionToken, username: user.name, task: task})
        })
        if (res.status === 204) {
            user.tasks[task.status] = user.tasks[task.status].filter(oldTask => oldTask.taskID !== task.taskID)
            const newUser = {...user}
            setUser(newUser)
        }
        else if (res.status === 401) {
            alert('Session Expired. Signed in on another device.')
            setUser(null)
            return
        }
        else {
            alert('Something went wrong while deleting the task. Please Try Again.', res.status)
            return
        }
    }

    // Update     
    const updateTask = async (task) => {
        // Create date stamp - verify data date.
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        if (dateStamp !== user.lastLogin) {
            alert('Session Expired. Please sign in again.')
            setUser(null)
            return
        }
        const res = await fetch('https://GradientBack.3-sigma.repl.co/task', {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({sessionToken: user.sessionToken, username: user.name, task: task})
        })
        if (res.status === 401) {
            alert('Session Expired. Signed in on another device.')
            setUser(null)
        }
        else if (res.status !== 204) {
            alert('Something went wrong while updating the task.', res.status)
        } else {
            user.tasks[task.status] = user.tasks[task.status].map((t) => {
                return t.taskID === task.taskID ? task : t
            })
            setUser({...user})
        }
    }

    // Helper "Packaged" Function
    const updateAndDismiss = (task) => {
        updateTask(task)
        dismiss()
    }

    const saveColor = (newColor) => {
        setColor(newColor)
        setTask({...task, color: newColor})
    }
   
    const form = 
        <div className = "form">
            <p className="form-element">Task Name</p>
            <input 
                type = 'text'
                placeholder='Task Name'
                value={task.name}
                onChange={(e) => {setTask({...task, name: e.target.value})}}
                className="form-element"
            />
            
            <p className="form-element"> Task Deadline </p>
            <input 
                type = 'date'
                placeholder='Task Deadline'
                value={task.deadline}
                onChange={(e) => {setTask({...task, deadline: e.target.value})}}
                className="form-element"
            />

            <p className="form-element"> Task Type </p>
            {/* TODO: make a picker. options passed in as taskTypes attribute. */}
            <input 
                type = 'text'
                placeholder='Task Type'
                value={task.type}
                onChange={(e) => {setTask({...task, type: e.target.value})}}
                className="form-element"
            />
            <div className = "form-element color-row">
                <p className="form-element"> Color </p>
                <div onClick={toggleColors} style={{ backgroundColor: color }} className="color-btn"/>  
            </div>

            {showColors && <TwitterPicker color={"#000"} onChangeComplete={ (color) => {saveColor(color.hex)}} triangle="top-right"/>}
            
            <p className="form-element"> Notes </p>
            <textarea className="form-element"
                placeholder='Notes'
                value={task.notes}
                cols="35"
                rows="5"
                onChange={(e) => {setTask({...task, notes: e.target.value})}}
            />

            <button onClick={()=>{updateAndDismiss(task)}} className="form-element"> Save </button>
            <button onClick={()=>{delTask(task)}} className="form-element"> Delete </button>

             <p className="form-element"> Reoccuring</p>
             <DayPicker/>

        </div>
    
    return <Popup task={task}
                dismiss={dismiss}
                content={form} />
}

export default EditTaskForm
